/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamZastup extends GContentBase<SeznamZastupObj> {
        private seznamObj: SeznamZastupObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamZastupObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamZastup",
                contentCaption: "jres:32131109",
                dataListDescriptor: this.dataListDescription,
                filterSettings: {
                    useHardDefaultFilter: (this.seznamObj.faze || this.seznamObj.ixs_fun || this.seznamObj.ixs_ref) ? true : false
                },
                comparatorSettings: {
                    itemTemplate: "{ixs_fun_txt} - {ixs_ref_txt}"
                },
                gridSettings: {
                    //columnOrder: "ixs_fun_txt,ixs_ref_txt,faze,faze_txt,dat_od,dat_do,ico,dat_zmena,zmenu_prov_txt"
                    columnOrder: this.seznamObj.createColumnOrder()
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamZastupObj extends GAdmSeznamBase {
        ixs_fun: string;
        ixs_ref: string;
        faze: string;

        openFromOsoba(): boolean {
            return this.ixs_ref ? true : false
        }

        createColumnOrder(): string {
            let columnOrder: string = "";
            if (this.ixs_fun) 
                columnOrder = "ixs_ref_txt,faze,faze_txt,"
            else if (this.ixs_ref)
                columnOrder = "ixs_fun_txt,faze,faze_txt,"
            else if (this.faze)
                columnOrder = "ixs_ref_txt,ixs_fun_txt,"
            else
                columnOrder = "ixs_fun_txt,ixs_ref_txt,faze,faze_txt,"
            columnOrder += "dat_od,dat_do,ico,dat_zmena,zmenu_prov_txt"
            return columnOrder;
        }

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailZastup", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openDialog: this.tabOpen,
                openFromOsoba: this.openFromOsoba()
            }]
            const inputParams = {
                ID: "DetailZastup",
                newRecord: isNew,
                ixs_fun: isNew == true ? (this.ixs_fun ? this.ixs_fun : null) : data.ixs_fun,
                ixs_ref: isNew == true ? (this.ixs_ref ? this.ixs_ref : null) : data.ixs_ref,
                faze: isNew == true ? (this.faze ? this.faze : null) : data.faze
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                "actOpenDetail*",
                "actNewDetail*",
                "actAddToComparison*",
                "actOpenDialogVyberovaSkupina*"
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDialogVyberovaSkupina*"
            ])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:33000003").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                name: "ixs_fun",
                model: "model.ixs_fun=value.ixs_fun",
                dropdown: true,
                disabled: this.ixs_fun ? true : false
            }).addRow("jres:33000004").addField("gselectbox", Gordic.Prefabs.Select.ginsref(), {
                name: "ixs_ref",
                model: "model.ixs_ref=value.ixs_ref",
                dropdown: true,
                disabled: this.ixs_ref ? true : false
            }).addRow("jres:32131111").addField("gselectbox", Gordic.Prefabs.Select.gincfaz(), {
                name: "faze",
                model: "model.faze=value.faze",
                dropdown: true,
                disabled: this.faze ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_fun)
                hardFilter["ixs_fun"] = this.ixs_fun;
            if (this.ixs_ref)
                hardFilter["ixs_ref"] = this.ixs_ref;
            if (this.faze)
                hardFilter["faze"] = this.faze;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_fun)
                data["ixs_fun"] = this.ixs_fun
            if (this.ixs_ref)
                data["ixs_ref"] = this.ixs_ref
            if (this.faze)
                data["faze"] = this.faze;
        }

        applydata(filterData: any, poradi_new?: number) {
            this.cnt.isl.Zastup.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data)
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
           
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_fun}#${data.ixs_ref}#${data.faze}#`,
                nazev: `${data.ixs_fun_txt} - ${data.ixs_ref_txt} - ${data.faze}`,
            }
        }
    }
}
